<template><section>

<h1>Select下拉框</h1>
<h2>基本用法</h2>
<p>下拉框选项通过options传递,要求每一项的value值<strong>必须唯一</strong></p>
<demo-block>
                    <div class="source" slot="source"><nt-select :options="options" v-model="sVal"></nt-select>
<p>当前选择项的value值为:{{sVal}}</p>



</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">nt-select</span> <span class="hljs-attr">:options</span>=<span class="hljs-string">"options"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"sVal"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">nt-select</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>当前选择项的value值为:{{sVal}}<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span>{
    data(){
        <span class="hljs-keyword">return</span> {
          <span class="hljs-attr">sVal</span>:<span class="hljs-string">'3'</span>,
          <span class="hljs-attr">options</span>: [{
                <span class="hljs-attr">text</span>: <span class="hljs-string">'北京大学	'</span>,
                <span class="hljs-attr">value</span>: <span class="hljs-string">'1'</span>
            }, {
                <span class="hljs-attr">text</span>: <span class="hljs-string">'清华大学	'</span>,
                <span class="hljs-attr">value</span>: <span class="hljs-string">'2'</span>
            }, {
                <span class="hljs-attr">text</span>: <span class="hljs-string">'复旦大学	'</span>,
                <span class="hljs-attr">value</span>: <span class="hljs-string">'3'</span>
            }, {
                <span class="hljs-attr">text</span>: <span class="hljs-string">'中国人民大学		'</span>,
                <span class="hljs-attr">value</span>: <span class="hljs-string">'4'</span>
            }, {
                <span class="hljs-attr">text</span>: <span class="hljs-string">'浙江大学		'</span>,
                <span class="hljs-attr">value</span>: <span class="hljs-string">'5'</span>
            }, {
                <span class="hljs-attr">text</span>: <span class="hljs-string">'中山大学		'</span>,
                <span class="hljs-attr">value</span>: <span class="hljs-string">'6'</span>
            }, {
                <span class="hljs-attr">text</span>: <span class="hljs-string">'上海交通大学	'</span>,
                <span class="hljs-attr">value</span>: <span class="hljs-string">'7'</span>
            }],
        }
    }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>


</code></pre>
</div></demo-block>
<h2>下拉框多选</h2>
<p>传递multiple属性,并通过v-model绑定一个数组(Array)</p>
<demo-block>
                    <div class="source" slot="source"><nt-select :options="options" v-model="sList" multiple></nt-select>
<p>当前选择项的value值为:{{sList}}</p>



</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">nt-select</span> <span class="hljs-attr">:options</span>=<span class="hljs-string">"options"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"sList"</span> <span class="hljs-attr">multiple</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">nt-select</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>当前选择项的value值为:{{sList}}<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span>{
    data(){
        <span class="hljs-keyword">return</span> {
          <span class="hljs-attr">sList</span>:[],
          <span class="hljs-attr">options</span>: [{
                <span class="hljs-attr">text</span>: <span class="hljs-string">'北京大学	'</span>,
                <span class="hljs-attr">value</span>: <span class="hljs-string">'1'</span>
            }, {
                <span class="hljs-attr">text</span>: <span class="hljs-string">'清华大学	'</span>,
                <span class="hljs-attr">value</span>: <span class="hljs-string">'2'</span>
            }, {
                <span class="hljs-attr">text</span>: <span class="hljs-string">'复旦大学	'</span>,
                <span class="hljs-attr">value</span>: <span class="hljs-string">'3'</span>
            }, {
                <span class="hljs-attr">text</span>: <span class="hljs-string">'中国人民大学		'</span>,
                <span class="hljs-attr">value</span>: <span class="hljs-string">'4'</span>
            }, {
                <span class="hljs-attr">text</span>: <span class="hljs-string">'浙江大学		'</span>,
                <span class="hljs-attr">value</span>: <span class="hljs-string">'5'</span>
            }, {
                <span class="hljs-attr">text</span>: <span class="hljs-string">'中山大学		'</span>,
                <span class="hljs-attr">value</span>: <span class="hljs-string">'6'</span>
            }, {
                <span class="hljs-attr">text</span>: <span class="hljs-string">'上海交通大学	'</span>,
                <span class="hljs-attr">value</span>: <span class="hljs-string">'7'</span>
            }],
        }
    }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>


</code></pre>
</div></demo-block>
<h2>下拉框禁用</h2>
<p>传递disabled属性,参数为Boolean值，默认为false</p>
<demo-block>
                    <div class="source" slot="source"><nt-select :options="options" v-model="sVal" :disabled="true"></nt-select>
<nt-select :options="options" v-model="sList" :disabled="true" multiple></nt-select>



</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">nt-select</span> <span class="hljs-attr">:options</span>=<span class="hljs-string">"options"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"sVal"</span> <span class="hljs-attr">:disabled</span>=<span class="hljs-string">"true"</span> &gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">nt-select</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">nt-select</span> <span class="hljs-attr">:options</span>=<span class="hljs-string">"options"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"sList"</span> <span class="hljs-attr">:disabled</span>=<span class="hljs-string">"true"</span> <span class="hljs-attr">multiple</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">nt-select</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span>{
    data(){
        <span class="hljs-keyword">return</span> {
          <span class="hljs-attr">sVal</span>:<span class="hljs-string">'3'</span>,
          <span class="hljs-attr">sList</span>:[<span class="hljs-string">'1'</span>,<span class="hljs-string">'3'</span>],
          <span class="hljs-attr">options</span>: [{
                <span class="hljs-attr">text</span>: <span class="hljs-string">'北京大学	'</span>,
                <span class="hljs-attr">value</span>: <span class="hljs-string">'1'</span>
            }, {
                <span class="hljs-attr">text</span>: <span class="hljs-string">'清华大学	'</span>,
                <span class="hljs-attr">value</span>: <span class="hljs-string">'2'</span>
            }, {
                <span class="hljs-attr">text</span>: <span class="hljs-string">'复旦大学	'</span>,
                <span class="hljs-attr">value</span>: <span class="hljs-string">'3'</span>
            }, {
                <span class="hljs-attr">text</span>: <span class="hljs-string">'中国人民大学		'</span>,
                <span class="hljs-attr">value</span>: <span class="hljs-string">'4'</span>
            }, {
                <span class="hljs-attr">text</span>: <span class="hljs-string">'浙江大学		'</span>,
                <span class="hljs-attr">value</span>: <span class="hljs-string">'5'</span>
            }, {
                <span class="hljs-attr">text</span>: <span class="hljs-string">'中山大学		'</span>,
                <span class="hljs-attr">value</span>: <span class="hljs-string">'6'</span>
            }, {
                <span class="hljs-attr">text</span>: <span class="hljs-string">'上海交通大学	'</span>,
                <span class="hljs-attr">value</span>: <span class="hljs-string">'7'</span>
            }],
        }
    }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>


</code></pre>
</div></demo-block>
<h2>下拉框change事件</h2>
<p>直接@change绑定change事件即可</p>
<demo-block>
                    <div class="source" slot="source"><nt-select :options="options" v-model="sVal" @change="handleChange"></nt-select>
<nt-select :options="options" v-model="sList" @change="handleMulChange" multiple></nt-select>



</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">nt-select</span> <span class="hljs-attr">:options</span>=<span class="hljs-string">"options"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"sVal"</span> <span class="hljs-attr">@change</span>=<span class="hljs-string">"handleChange"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">nt-select</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">nt-select</span> <span class="hljs-attr">:options</span>=<span class="hljs-string">"options"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"sList"</span>  <span class="hljs-attr">@change</span>=<span class="hljs-string">"handleMulChange"</span> <span class="hljs-attr">multiple</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">nt-select</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span>{
    data(){
        <span class="hljs-keyword">return</span> {
          <span class="hljs-attr">sVal</span>:<span class="hljs-string">'3'</span>,
          <span class="hljs-attr">sList</span>:[<span class="hljs-string">'1'</span>,<span class="hljs-string">'3'</span>],
          <span class="hljs-attr">options</span>: [{
                <span class="hljs-attr">text</span>: <span class="hljs-string">'北京大学	'</span>,
                <span class="hljs-attr">value</span>: <span class="hljs-string">'1'</span>
            }, {
                <span class="hljs-attr">text</span>: <span class="hljs-string">'清华大学	'</span>,
                <span class="hljs-attr">value</span>: <span class="hljs-string">'2'</span>
            }, {
                <span class="hljs-attr">text</span>: <span class="hljs-string">'复旦大学	'</span>,
                <span class="hljs-attr">value</span>: <span class="hljs-string">'3'</span>
            }, {
                <span class="hljs-attr">text</span>: <span class="hljs-string">'中国人民大学		'</span>,
                <span class="hljs-attr">value</span>: <span class="hljs-string">'4'</span>
            }, {
                <span class="hljs-attr">text</span>: <span class="hljs-string">'浙江大学		'</span>,
                <span class="hljs-attr">value</span>: <span class="hljs-string">'5'</span>
            }, {
                <span class="hljs-attr">text</span>: <span class="hljs-string">'中山大学		'</span>,
                <span class="hljs-attr">value</span>: <span class="hljs-string">'6'</span>
            }, {
                <span class="hljs-attr">text</span>: <span class="hljs-string">'上海交通大学	'</span>,
                <span class="hljs-attr">value</span>: <span class="hljs-string">'7'</span>
            }],
        }
    },
    <span class="hljs-attr">methods</span>:{
        handleChange(val){
            alert(<span class="hljs-string">`单选框改变，更新后的key值为<span class="hljs-subst">${val}</span>`</span>)
        },
        handleMulChange(val){
            alert(<span class="hljs-string">`multipleSelect改变，更新后的key值数组为<span class="hljs-subst">${val}</span>`</span>)
        },
    }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>


</code></pre>
</div></demo-block>
<h3>Attributes</h3>
<table>
<thead>
<tr>
<th style="text-align:left">参数</th>
<th style="text-align:left">说明</th>
<th style="text-align:left">类型</th>
<th style="text-align:left">可选值</th>
<th style="text-align:left">默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">disabled</td>
<td style="text-align:left">是否禁用</td>
<td style="text-align:left">Boolean</td>
<td style="text-align:left"><code v-pre>true</code> <code v-pre>false</code></td>
<td style="text-align:left"><code v-pre>false</code></td>
</tr>
<tr>
<td style="text-align:left">multiple</td>
<td style="text-align:left">是否多选</td>
<td style="text-align:left">-</td>
<td style="text-align:left">直接加上这个属性即可，默认不加</td>
<td style="text-align:left"><code v-pre>无</code></td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th style="text-align:left">事件名称</th>
<th style="text-align:left">说明</th>
<th style="text-align:center">回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">change</td>
<td style="text-align:left">直接@change绑定change事件即可</td>
<td style="text-align:center">Event</td>
</tr>
</tbody>
</table>
</section></template>
<style>
    p{
        font-size:14px;
    }
</style>
<script>
export default{
    data(){
        return {
          sVal:'3',
          sList:['1','3'],
          options: [{
                text: '北京大学	',
                value: '1'
            }, {
                text: '清华大学	',
                value: '2'
            }, {
                text: '复旦大学	',
                value: '3'
            }, {
                text: '中国人民大学		',
                value: '4'
            }, {
                text: '浙江大学		',
                value: '5'
            }, {
                text: '中山大学		',
                value: '6'
            }, {
                text: '上海交通大学	',
                value: '7'
            }],
        }
    },
    methods:{
        handleChange(val){
            alert(`单选框改变，更新后的key值为${val}`)
        },
        handleMulChange(val){
            alert(`multipleSelect改变，更新后的key值数组为${val}`)
        },
    }
}
</script>